var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAgileStrategies = function SvgAgileStrategies(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 144,
    fill: "none",
    viewBox: "0 0 144 144"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3144",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M47.253 88.8h92.672c1.13 0 2.046-.916 2.046-2.046V24.045c0-1.13-.916-2.045-2.046-2.045H47.253c-1.13 0-2.046.916-2.046 2.045v62.709c0 1.13.916 2.045 2.046 2.045Z",
    className: "agile-strategies_svg__white-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3144",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M52.032 80.286h83.311c.959 0 1.737-.778 1.737-1.737v-50.33c0-.96-.778-1.737-1.737-1.737H52.032c-.96 0-1.737.778-1.737 1.737v50.33c0 .959.778 1.737 1.737 1.737ZM100.186 88.8h-16.18l-3.7 13.695h26.579l-3.699-13.696Z",
    className: "agile-strategies_svg__white-stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    d: "M90.604 95.528a2.964 2.964 0 1 1 5.927.059 2.964 2.964 0 0 1-5.927-.059m1.903 0a1.084 1.084 0 1 0 2.169-.012 1.084 1.084 0 0 0-2.17.012",
    className: "agile-strategies_svg__white-figure"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M120.942 102.495h-54.49",
    className: "agile-strategies_svg__white-stroke"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M123.925 37.212H69.428M123.925 60.228H79.471M123.925 44.938h-15.759",
    className: "agile-strategies_svg__orange-stroke"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M123.925 52.658h-15.759",
    className: "agile-strategies_svg__white-stroke"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M123.925 67.923h-15.759",
    className: "agile-strategies_svg__orange-stroke"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M99.718 44.938H83.959",
    className: "agile-strategies_svg__white-stroke"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#2C3144",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M7.864 121.277h51.84a5.864 5.864 0 0 0 5.864-5.864V64.616a5.864 5.864 0 0 0-5.863-5.864H7.864A5.864 5.864 0 0 0 2 64.616v50.797a5.864 5.864 0 0 0 5.864 5.864Z",
    className: "agile-strategies_svg__white-stroke-fill"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    d: "M30.914 114.482a2.8 2.8 0 1 1 2.798 2.805 2.806 2.806 0 0 1-2.798-2.805m1.779 0a1.014 1.014 0 1 0 .626-.94 1.015 1.015 0 0 0-.62.94z",
    className: "agile-strategies_svg__white-figure"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3144",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M64.874 107.25H2.557",
    className: "agile-strategies_svg__white-stroke"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    stroke: "#2C3144",
    strokeMiterlimit: 10,
    d: "m32.504 100.206-.522-3.492a10 10 0 0 1-1.695-.457l-2.206 2.769a.255.255 0 0 1-.326.06l-1.654-.956a.255.255 0 0 1-.107-.314l1.293-3.29q-.677-.57-1.245-1.245l-3.29 1.292a.255.255 0 0 1-.315-.106l-.954-1.654a.27.27 0 0 1 .059-.327l2.768-2.205a9.4 9.4 0 0 1-.45-1.696l-3.498-.521a.26.26 0 0 1-.22-.255v-.955a.25.25 0 0 1 .256-.249.255.255 0 0 1 .254.25v.74l3.463.522a.24.24 0 0 1 .213.207 9.4 9.4 0 0 0 .522 1.95.26.26 0 0 1-.077.291l-2.745 2.182.741 1.275 3.26-1.28a.26.26 0 0 1 .291.076 9.6 9.6 0 0 0 1.43 1.43.26.26 0 0 1 .076.29l-1.298 3.26 1.274.742 2.182-2.74a.25.25 0 0 1 .29-.076c.631.239 1.285.412 1.951.515a.26.26 0 0 1 .214.214l.516 3.462h1.476l.522-3.462a.26.26 0 0 1 .207-.214 9.6 9.6 0 0 0 1.957-.516.25.25 0 0 1 .29.078l2.182 2.739 1.275-.742-1.281-3.26a.25.25 0 0 1 .077-.29 10 10 0 0 0 1.429-1.43.27.27 0 0 1 .29-.077l3.261 1.28.735-1.274-2.739-2.176a.25.25 0 0 1-.077-.29 9.5 9.5 0 0 0 .522-1.957.24.24 0 0 1 .213-.207l3.463-.522v-.74a.254.254 0 1 1 .51 0v.96a.255.255 0 0 1-.22.249l-3.498.521q-.154.871-.456 1.702l2.768 2.2a.26.26 0 0 1 .066.326l-.943 1.665a.243.243 0 0 1-.308.107l-3.297-1.292q-.565.676-1.239 1.245l1.293 3.29a.255.255 0 0 1-.107.314l-1.654.955a.255.255 0 0 1-.326-.06l-2.206-2.78c-.55.2-1.118.353-1.695.457l-.528 3.492a.25.25 0 0 1-.084.155.25.25 0 0 1-.165.064h-1.909a.262.262 0 0 1-.255-.219Zm-3.93-13.352a.255.255 0 0 1 .503 0 4.636 4.636 0 0 0 9.273 0 .256.256 0 0 1 .504 0 5.14 5.14 0 0 1-10.28 0Z",
    className: "agile-strategies_svg__orange-shadow"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    stroke: "#2C3144",
    strokeMiterlimit: 10,
    d: "M18.428 84.88a.255.255 0 0 1 .255-.249h23.715a.255.255 0 1 1 0 .504H18.683a.255.255 0 0 1-.255-.255Zm26.217 0a.25.25 0 0 1 .158-.231.3.3 0 0 1 .097-.018h3.842a.254.254 0 0 1 .154.418.25.25 0 0 1-.154.086h-3.836a.256.256 0 0 1-.261-.255Z",
    className: "agile-strategies_svg__orange-stroke"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    stroke: "#2C3144",
    strokeMiterlimit: 10,
    d: "M42.143 84.88a1.506 1.506 0 1 1 3.01 0 1.506 1.506 0 0 1-3.01 0Zm.504 0a1.002 1.002 0 1 0 1.997.154 1.002 1.002 0 0 0-1.997-.154Z",
    className: "agile-strategies_svg__white-stroke"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    stroke: "#2C3144",
    strokeMiterlimit: 10,
    d: "M18.428 80.292a.255.255 0 0 1 .255-.255h18.112a.254.254 0 0 1 .109.497.3.3 0 0 1-.109.007H18.683a.255.255 0 0 1-.255-.25Zm20.62 0a.255.255 0 0 1 .255-.255h9.439a.254.254 0 0 1 0 .504h-9.44a.25.25 0 0 1-.254-.25Z",
    className: "agile-strategies_svg__orange-stroke"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    stroke: "#2C3144",
    strokeMiterlimit: 10,
    d: "M36.545 80.292a1.506 1.506 0 1 1 3.012 0 1.506 1.506 0 0 1-3.012 0Zm.504 0a1.002 1.002 0 1 0 1.998.154 1.002 1.002 0 0 0-1.998-.154Z",
    className: "agile-strategies_svg__white-stroke"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    stroke: "#2C3144",
    strokeMiterlimit: 10,
    d: "M18.428 75.697a.255.255 0 0 1 .255-.25h8.816a.254.254 0 0 1 .109.498.3.3 0 0 1-.11.007h-8.815a.255.255 0 0 1-.255-.255Zm11.324 0a.25.25 0 0 1 .255-.25h18.735a.254.254 0 0 1 0 .505H30.007a.255.255 0 0 1-.255-.255Z",
    className: "agile-strategies_svg__orange-stroke"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    stroke: "#2C3144",
    strokeMiterlimit: 10,
    d: "M27.25 75.697a1.506 1.506 0 1 1 3.012 0 1.506 1.506 0 0 1-3.012 0Zm.504 0a1.003 1.003 0 1 0 2.006.011 1.003 1.003 0 0 0-2.006-.011Z",
    className: "agile-strategies_svg__white-stroke"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    stroke: "#2C3144",
    strokeMiterlimit: 10,
    d: "M18.428 71.102a.255.255 0 0 1 .255-.249h16.784a.255.255 0 1 1 0 .504H18.683a.255.255 0 0 1-.255-.255Zm19.292 0a.25.25 0 0 1 .158-.232.3.3 0 0 1 .097-.017h10.767a.254.254 0 0 1 0 .504H37.975a.255.255 0 0 1-.255-.255Z",
    className: "agile-strategies_svg__orange-stroke"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    stroke: "#2C3144",
    strokeMiterlimit: 10,
    d: "M35.213 71.102a1.506 1.506 0 1 1 3.012.012 1.506 1.506 0 0 1-3.012-.012Zm.51 0a1.001 1.001 0 1 0 2.002.024 1.001 1.001 0 0 0-2.002-.024Z",
    className: "agile-strategies_svg__white-stroke"
  })));
};
export default SvgAgileStrategies;